import * as yup from 'yup'

export class DamagePhoto3Dto {
  damagePhoto3FileName?: string = undefined
  damagePhoto3File?: File | string = undefined
}

export const DamagePhoto3DtoSchema = yup.object({
  damagePhoto3FileName: yup.string().nullable(),
  damagePhoto3File: yup.mixed()
})
